<template>
    <!-- <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value)">
      <span>{{ (params.value ? 'Active' : 'Inactive') }}</span>
    </vs-chip> -->
    <span class="feather-icon select-none relative switch-publish" title="Published / Un-Published">
      <vs-switch v-model="params.data.IsPublished">
        <!--<span slot="on">Published</span>
        <span slot="off">Un-Published</span>-->
      </vs-switch>
    </span>
</template>

<script>
  import { bus } from "../../../../main";
export default {
  name: 'CellRendererStatus',
  watch: {
    "params.data.IsPublished"() {
        bus.$emit("changeLocationStatus", this.params.data);
    }
  },
  methods: {

  },
  computed: {
 
  }
}
</script>

